import React, {useState} from 'react';
import styles from "./UpdatePaymentTypePopUp.module.css";
import Modal from "react-modal";
import {PaymentType} from "../../../types/contract";
import {updatePaymentTypeAPI} from "../../../services/client";

interface UpdatePaymentTypePopUpProps {
    isOpen: boolean;
    onClose: () => void;
}

//첫 결제 방법 등록 팝업 페이지
const UpdatePaymentTypePopUp: React.FC<UpdatePaymentTypePopUpProps> = ({
                                                                           isOpen,
                                                                           onClose
                                                                       }) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [paymentType, setPaymentType] = useState<string>(PaymentType.계좌이체);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            //결제 방법 수정 API
            await updatePaymentTypeAPI(paymentType);
            onClose();
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleStatusChange = (type: PaymentType) => {
        setPaymentType(type);
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>결제방법 등록</h2>
                    {/*팝업 닫기 버튼*/}
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Close"
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        {/*결제방법 선택, 카드/계좌이체*/}
                        <select
                            value={paymentType}
                            onChange={(e) => handleStatusChange(e.target.value as PaymentType)}
                            className={styles.select}
                            required
                            disabled={isSubmitting}
                        >
                            <option value={PaymentType.계좌이체}>{PaymentType.계좌이체}</option>
                            <option value={PaymentType.신용카드}>{PaymentType.신용카드}</option>
                        </select>
                    </div>
                    {/*저장 버튼*/}
                    <button
                        type="submit"
                        className={styles.submitButton}
                    >
                        {isSubmitting ? '처리 중...' : '등록'}
                    </button>
                </form>
            </div>
        </Modal>
    );
}

export default UpdatePaymentTypePopUp;